import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import MaskedInput from 'react-text-mask';
import colors from 'shared-assets/lib/colors';
import Input from 'shared-assets/components/Elements/Input';
import IconButton from 'shared-assets/components/IconButton';
import Spinner from 'shared-assets/components/Spinner';

const ErrorText = styled.span`
  color: ${colors.error};
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  min-height: 2rem;
`;

class InlineEdit extends React.Component {
  state = {
    edit: false,
    error: false,
    inputText: null,
  };

  static propTypes = {
    edit: PropTypes.bool,
    text: PropTypes.string,
    hideIcon: PropTypes.bool,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    onSave: PropTypes.func,
    isSaving: PropTypes.bool,
    inputProps: PropTypes.object,
    inputMaskProps: PropTypes.object,
    inputRef: PropTypes.func,
    error: PropTypes.any,
    size: PropTypes.string,
  };

  static defaultProps = {
    edit: undefined,
    text: undefined,
    hideIcon: false,
    onChange: undefined,
    onBlur: undefined,
    onSave: undefined,
    isSaving: undefined,
    inputProps: undefined,
    inputMaskProps: undefined,
    inputRef: undefined,
    error: undefined,
    size: undefined,
  };

  static getDerivedStateFromProps(newProps, state) {
    if (newProps.inputProps && newProps.inputProps.value) {
      return {
        inputText: newProps.inputProps.value,
        edit: !state.edit ? !newProps.text || !!newProps.edit : state.edit,
      };
    }

    return {
      edit: !state.edit ? !newProps.text || !!newProps.edit : state.edit,
    };
  }

  handleChange = e => {
    this.setState({
      inputText: e.target.value,
    });

    if (this.props.onChange && typeof this.props.onChange === 'function') {
      this.props.onChange(e.target.value, e);
    }
  };

  handleKeyDown = e => {
    let newState = {};
    if (e.key === 'Enter') {
      if (!!e.target.value) {
        newState.edit = false;
      }
      if (this.props.onSave && typeof this.props.onSave === 'function') {
        this.props.onSave(e.target.value, e);
      }
      e.preventDefault();
    }

    if (e.key === 'Escape') {
      newState.edit = false;
      newState.inputText = null;
      e.preventDefault();
    }

    this.setState(newState);
  };

  handleBlur = e => {
    if (!!e.target.value) {
      this.setState({ edit: false });
    }
    if (this.props.onBlur && typeof this.props.onBlur === 'function') {
      this.props.onBlur(e.target.value, e);
    }
  };

  render() {
    let text =
      !!this.props.text && this.state.inputText === null
        ? this.props.text
        : this.state.inputText;

    const { inputMaskProps } = this.props;

    const inputConfig = {
      'data-testid': 'patient-intake-email-input',
      status: !!this.state.error ? 'error' : null,
      disabled: !!this.props.isSaving,
      size: !!text ? text.length + 1 : 1,
      ref: inputElem => {
        if (this.props.inputRef && typeof this.props.inputRef === 'function') {
          this.props.inputRef(inputElem);
        }

        return this.state.edit && inputElem;
      },
      name: this.props.text,
      style: { marginBottom: 0, minWidth: '150px' },
      placeholder: 'Email Address',
      value: text || '',
      ...this.props.inputProps,
      onChange: this.handleChange,
      onKeyDown: this.handleKeyDown,
      onBlur: this.handleBlur,
    };

    return (
      <Wrapper>
        {/** Row's height is set to make sure the text when editing is inline with the non editing text.
         * This height should equal the height of the Input field
         */}
        <If condition={this.state.edit || !!this.props.isSaving}>
          <div>
            <Wrapper style={{ alignItems: 'center' }}>
              {inputMaskProps && (
                <MaskedInput
                  id="text-maskd65ft7guyihoj"
                  {...inputConfig}
                  {...inputMaskProps}
                />
              )}
              {!inputMaskProps && <Input {...inputConfig} />}
              <If condition={this.props.isSaving}>
                <div style={{ marginLeft: '0.3rem' }}>
                  <Spinner size={this.props.size} />
                </div>
              </If>
            </Wrapper>
            <If condition={!!this.props.error}>
              <div>
                <ErrorText>{this.props.error}</ErrorText>
              </div>
            </If>
          </div>
        </If>
        <If condition={!this.state.edit && text && !this.props.isSaving}>
          <div>
            <Wrapper style={{ alignItems: 'center' }}>
              <div>{text}</div>
              <If condition={!this.props.hideIcon}>
                <div style={{ marginLeft: '0.3rem' }}>
                  <IconButton
                    data-testid="patient-intake-email-edit-button"
                    disabled={!!this.props.isSaving}
                    icon="edit"
                    onClick={e => {
                      this.setState({
                        edit: !this.state.edit,
                      });
                      e.preventDefault();
                    }}
                  />
                </div>
              </If>
            </Wrapper>
            <If condition={!!this.props.error}>
              <div>
                <ErrorText>{this.props.error}</ErrorText>
              </div>
            </If>
          </div>
        </If>
      </Wrapper>
    );
  }
}

export default InlineEdit;
